export default __webpack_public_path__ + "static/media/marker.85a633b7.svg";